<div class="main-container">
  <app-header></app-header>
  @if (networkStatus.isOffline()) {
  <div class="offline-banner">
    <mat-icon class="offline-icon">wifi_off</mat-icon>
    <span class="body-small offline-text">Você está sem conexão. As alterações não estão sendo salvas. Retome quando a
      conexão for restabelecida.</span>
    <button mat-stroked-button class="reconnect-btn" [disabled]="networkStatus.isCheckingConnection()"
      (click)="networkStatus.tryReconnect()">
      @if (networkStatus.isCheckingConnection()) {
      <mat-spinner diameter="14" />
      }
      Tentar reconectar
    </button>
  </div>
  }
  <mat-drawer-container class="main-page">
    <mat-drawer id="sidebar" mode="side" opened [class.extended]="isSidebarExtended" class="nav-content sidebar"
      (mouseenter)="isSidebarExtended = true" (mouseleave)="isSidebarExtended = false">
      <nav class="sidebar-nav">
        @for (link of navLinks(); track link.route) {
        <a [routerLink]="link.route" routerLinkActive="active-link" class="sidebar-link"
          [matTooltip]="link.label" matTooltipPosition="right" [matTooltipShowDelay]="300">
          <mat-icon fontSet="material-icons-outlined" class="sidebar-icon">{{ link.icon }}</mat-icon>
          <span class="sidebar-label">{{ link.label }}</span>
        </a>
        }
      </nav>

      <div class="sidebar-footer">

        <button class="sidebar-settings" routerLink="/main/configuracoes"
          routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: false }"
          matTooltip="Configurações" matTooltipPosition="right" [matTooltipShowDelay]="300">
          <mat-icon fontSet="material-icons-outlined" class="sidebar-icon">settings</mat-icon>
          <span class="sidebar-label">Configurações</span>
        </button>
        <button class="sidebar-logout" (click)="confirmLogout()"
          matTooltip="Sair da conta" matTooltipPosition="right" [matTooltipShowDelay]="300">
          <mat-icon fontSet="material-icons-outlined" class="sidebar-icon sidebar-logout-icon">logout</mat-icon>
          <span class="sidebar-label sidebar-logout-label">Sair da conta</span>
        </button>
      </div>
    </mat-drawer>
    <mat-drawer-content class="page-content">
      <div class="page-content-inner">
        <app-breadcrumb></app-breadcrumb>
        <app-page-title></app-page-title>
        <router-outlet></router-outlet>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>